import api from '../api';
import { tokenService } from '../auth/tokenService';

export const customer = {
  getList: async (params) => {
    try {
      const response = await api.get('customers/app', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  downloadCustomers: async (params) => {
    try {
      const response = await api.get('customers/download', {
        params,
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'customers.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading customers:', error);
    }
  },

  toggleStatus: async (id, status) => {
    try {
      const response = await api.patch(`customers/${id}/status?status=${status}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`customers/${id}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  download: async (params) => {
    try {
      const response = await api.get('customers/export', {
        responseType: 'blob',
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      });

      // Crear el blob y el enlace de descarga
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDataCustomer: async (user_id) => {
    try {
      const response = await api.get(`customers/${user_id}/personal-data`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  serviceOffered: async (user_id, params) => {
    try {
      const response = await api.get(`users/cms/${user_id}/services-offered`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  requestReceived: async (user_id, params) => {
    try {
      const response = await api.get(`users/cms/${user_id}/services-received`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  requestHistory: async (user_id, params) => {
    try {
      const response = await api.get(`users/cms/${user_id}/services-received`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  tokenHistory: async (user_id, params) => {
    try {
      const response = await api.get(`tokens/operations-history/user/${user_id}`, {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  balance: async (user_id) => {
    try {
      const response = await api.get(`tokens/balance/user/${user_id}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}